// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldeditEntity from './entities/ldedit.json';
import ldeditMenu from '../pages/ldedit/menu.json';
import ldeditFullForm from '../pages/ldedit/forms/full.json';
import ldeditContextForm from '../pages/ldedit/forms/context.json';
import ldeditMiniForm from '../pages/ldedit/forms/mini.json';
import ldeditLookupForm from '../pages/ldedit/forms/lookup.json';
import ldeditTableView from '../pages/ldedit/views/table.json';
import ldeditStagesView from '../pages/ldedit/views/stages.json';
import ldeditCardsView from '../pages/ldedit/views/cards.json';
import ldeditInlineView from '../pages/ldedit/views/inline.json';
import ldeditBacklogView from '../pages/ldedit/views/backlog.json';
import ldeditSplitView from '../pages/ldedit/views/split.json';
import ldeditCalendarView from '../pages/ldedit/views/calendar.json';
import ldeditDashboardView from '../pages/ldedit/views/dashboard.json';

/** Тип запису «Правка» зі сторінками пакета: меню, форми та подання з pages/ldedit/. */
export const ldeditDefinition: IRecordTypeDefinition = {
  ...ldeditEntity,
  views: assembleViewSet({
      table: ldeditTableView,
      stages: ldeditStagesView,
      cards: ldeditCardsView,
      inline: ldeditInlineView,
      backlog: ldeditBacklogView,
      split: ldeditSplitView,
      calendar: ldeditCalendarView,
      dashboard: ldeditDashboardView,
  }),
  form: ldeditFullForm,
  forms: { full: ldeditFullForm, context: ldeditContextForm, mini: ldeditMiniForm, lookup: ldeditLookupForm },
  menu: ldeditMenu,
} as IRecordTypeDefinition;
